import { BaseEntity } from 'yt-ng-framework';

export class PravoNaGo extends BaseEntity {
  constructor() {
      super();
  }
  OrgJedObrazacZaGoID: number = null;
  OrgJedID: number = null;
  OsobaID: number = null;
  Godina: number = null;



  Deserialize(input: any) {
      this.ID = input.ID;
      //this.OrgJedID = input.OrgJedID;
      this.OrgJedObrazacZaGoID = input.OrgJedObrazacZaGoID;
      this.OsobaID = input.OsobaID;
      this.Godina = input.Godina;

      return this;
  }

  Serialize(input: PravoNaGo) {
      return input;      
  }
}
